import o from "./ScalarModal.vue2.js";
import { useModal as s } from "./ScalarModal.vue2.js";
import "./ScalarModal.vue3.js";
import a from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ a(o, [["__scopeId", "data-v-589f8aa0"]]);
export {
  m as default,
  s as useModal
};
